import { Functionality } from '../context/Functionality';
import { useState, useEffect, useContext } from 'react';
import { FaCalculator, FaChevronDown } from 'react-icons/fa';
import { MdBusinessCenter } from "react-icons/md";
import { BsFillFileEarmarkPostFill } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import { Link, NavLink, useLocation } from 'react-router-dom';

const Sidebar = (props) => {
    const { toggleSidebar } = props;
    const { user } = useContext(Functionality) || {};
    const { pathname } = useLocation();
    const [calculatorsOpen, setCalculatorsOpen] = useState(pathname.startsWith('/calculators/'));
    useEffect(() => { if (pathname.startsWith('/calculators/')) setCalculatorsOpen(true); }, [pathname]);

    return (
        <div>
            <div
            >
                <div className=" text-black">
                    <div className='p-2'>
                        <div className="text-1xl font-bold text-center ">
                            <Link to={'/'}>
                                <img width="100" height="100" className="w-100 mx-auto" src="/Logowhite.png" alt="Your Company" />
                            </Link>
                        </div>
                        <div className="block md:hidden absolute top-5 right-5">
                            <MdClose style={{ fontSize: '25px', color: 'white', cursor: 'pointer' }} onClick={toggleSidebar} />
                        </div>
                    </div>
                    <div className="h-full px-3 py-4 overflow-y-auto">
                        <ul className="space-y-2 font-medium">
                            <li><Link onClick={toggleSidebar} to="/account-portals" className="block p-2 rounded-lg text-white hover:bg-gray-700">Client projects</Link></li>
                            <li><Link onClick={toggleSidebar} to="/referrals" className="block p-2 rounded-lg text-white hover:bg-gray-700">Referrals</Link></li>
                            {user?.isAdmin && <li><Link onClick={toggleSidebar} to="/automation-tokens" className="block p-2 rounded-lg text-white hover:bg-gray-700">Blog automation tokens</Link></li>}
                            <li>
                                <Link onClick={toggleSidebar} to="/business-list" className="flex items-center p-2 text-gray-900  rounded-lg dark:text-white hover:bg-gray-900 dark:hover:bg-gray-700 group">
                                    <MdBusinessCenter style={{ fontSize: '25px', color: 'white' }} />
                                    <span className="ms-3 text-white ">Business List</span>
                                </Link>
                            </li>
                            <li>
                                <Link onClick={toggleSidebar} to="/blog-post" className="flex items-center p-2 text-gray-900  rounded-lg dark:text-white hover:bg-gray-900 dark:hover:bg-gray-700 group">
                                    <BsFillFileEarmarkPostFill style={{ fontSize: '25px', color: 'white' }} />
                                    <span className="ms-3 text-white ">Blog Post</span>
                                </Link>
                            </li>
                            <li>
                                <button type="button" onClick={() => setCalculatorsOpen(open => !open)} aria-expanded={calculatorsOpen} aria-controls="calculator-links" className="flex items-center w-full p-2 rounded-lg text-white hover:bg-gray-700 text-left">
                                    <FaCalculator size={25} aria-hidden="true" /><span className="ms-3">Calculators</span><FaChevronDown aria-hidden="true" className={`ml-auto transition-transform ${calculatorsOpen ? 'rotate-180' : ''}`} />
                                </button>
                                {calculatorsOpen && <ul id="calculator-links" className="ml-8 mt-2 space-y-1">
                                    {[['private-equity', 'Private Equity'], ['business', 'Business']].map(([slug, label]) => <li key={slug}><NavLink to={`/calculators/${slug}`} onClick={toggleSidebar} className={({ isActive }) => `block px-3 py-3 rounded-lg text-sm ${isActive ? 'bg-indigo-700 text-white' : 'text-gray-200 hover:bg-gray-700'}`}>{label}</NavLink></li>)}
                                </ul>}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
